import React from 'react';
import { Icon } from 'antd';
import './ClientTypeCard.css';

interface Props {
  icon: string;
  title: string;
  description: string;
  tag?: string;
  tagVariant?: 'default' | 'purple';
  selected: boolean;
  onClick: () => void;
}

const ClientTypeCard: React.FC<Props> = ({
  icon,
  title,
  description,
  tag,
  tagVariant = 'default',
  selected,
  onClick,
}) => (
  <button
    type="button"
    className={`client-type-card${selected ? ' client-type-card--selected' : ''}`}
    onClick={onClick}
    role="radio"
    aria-checked={selected}
  >
    <div className="client-type-card__top">
      <span className="client-type-card__icon">
        <Icon type={icon} />
      </span>
      <span className="client-type-card__radio">
        {selected && <span className="client-type-card__radio-dot" />}
      </span>
    </div>
    <div className="client-type-card__body">
      <div className="client-type-card__title">{title}</div>
      <div className="client-type-card__desc">{description}</div>
      {tag && (
        <span className={`client-type-card__tag${tagVariant === 'purple' ? ' client-type-card__tag--purple' : ''}`}>
          {tag}
        </span>
      )}
    </div>
  </button>
);

export default ClientTypeCard;
